import { render, staticRenderFns } from "./VariousResultDownload.vue?vue&type=template&id=1d1d288e&scoped=true&"
import script from "./VariousResultDownload.vue?vue&type=script&lang=ts&"
export * from "./VariousResultDownload.vue?vue&type=script&lang=ts&"
import style0 from "./VariousResultDownload.vue?vue&type=style&index=0&id=1d1d288e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1d288e",
  null
  
)

export default component.exports